"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipContent;

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UITooltipContent(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react.default.createElement("div", {
    className: (0, _classNames.default)('private-tooltip__inner', className),
    role: "tooltip"
  }, children);
}

UITooltipContent.propTypes = {
  children: _react.PropTypes.node
};
UITooltipContent.displayName = 'UITooltipContent';
module.exports = exports.default;